import {store} from '@/store';
import {userAtom} from '@/store/user';
import {buildMbApiUrl, fetchWithTimeout} from '@/util/request-utils';

interface GenerateVideoResponse {
    request_id?: string;
}

interface VideoResultsResponse {
    finished: boolean;
    output?: string[];
}

export async function generateVideo(
    prompt: string,
    imageUrl: string,
    method: 'generate_veo3' | 'generateminimax' = 'generate_veo3'
): Promise<GenerateVideoResponse> {
    const user = store.get(userAtom);
    if (!user?.auth_token) {
        throw new Error('User not authenticated');
    }

    const url = buildMbApiUrl('/ai_lifestyles/generate_video.json', {
        auth_token: user.auth_token,
    });

    const response = await fetchWithTimeout(url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            positive_prompt: prompt,
            image_url: imageUrl,
            method: method,
        }),
    });

    if (!response.ok) {
        throw new Error(`Failed to generate video: ${response.status}`);
    }

    return response.json();
}

export async function getVideoResults(
    requestId: string
): Promise<VideoResultsResponse> {
    const user = store.get(userAtom);
    if (!user?.auth_token) {
        throw new Error('User not authenticated');
    }

    const url = buildMbApiUrl(
        '/ai_lifestyles/results.json',
        {auth_token: user.auth_token},
        {request_id: requestId, type: 'generate_image'}
    );

    const response = await fetchWithTimeout(url);
    if (!response.ok) {
        throw new Error(`Failed to get video results: ${response.status}`);
    }

    return response.json();
}
